import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { receiveMessageAction } from 'store/message/messageActions';
import logger from 'logger';

MessageWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};
export default function MessageWrapper({ children }) {
  const dispatch = useDispatch();
  const [hasInitialized, setHasInitialized] = useState(false);
  const { socket } = useSelector(({ message }) => ({
    socket: message.socket,
  }));

  useEffect(() => {
    if (socket && !hasInitialized) {
      socket.addEventListener('message', function (event) {
        try {
          const message = JSON.parse(event.data);
          dispatch(receiveMessageAction({ message }));
        } catch (e) {
          logger.error('ERROR IN THE CHAT WRAPPER ', e);
        }
      });
      setHasInitialized(true);
    }
    return () => {
      if (socket) {
        socket
          .close()
          .then(() => {})
          .catch((e) => {
            console.error('error closing socket', e);
          });
      }
      setHasInitialized(false);
    };
    //eslint-disable-next-line
  }, [socket]);
  return children;
}
